var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isActive
    ? _c("modal", {
        staticClass: "identify-panel loader-panel",
        attrs: {
          show: _vm.showModal,
          showContent: _vm.showContent,
          pageTitle: _vm.title,
          acl: _vm.acl,
          url: _vm.url,
          closeBtn: _vm.closeBtn,
          position: "right",
          size: "medium",
          id: "identify-container",
          classContent: "overflow-hidden",
        },
        on: { close: _vm.closeModal },
        scopedSlots: _vm._u(
          [
            {
              key: "content",
              fn: function () {
                return [
                  _c("div", { staticClass: "d-flex flex-column" }, [
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col" }, [
                        _c("div", { staticClass: "title" }, [
                          _vm._v(" " + _vm._s(_vm.title)),
                        ]),
                        _vm._v(" "),
                        _c("hr"),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col" }, [
                        _c("div", { staticClass: "row" }, [
                          _c(
                            "div",
                            { staticClass: "col-12" },
                            [
                              _c("IdentifyLayer", {
                                ref: "identifyLayer",
                                attrs: {
                                  index: _vm.index,
                                  responses: _vm.responses,
                                  missingResponses: _vm.missingResponses,
                                  emptyResponses: _vm.emptyResponses,
                                  validator: _vm.currentValidator,
                                  disabled: _vm.readonlyFormItem || _vm.loading,
                                },
                                on: { onChangeIndex: _vm.onChangeIndex },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.isCoordinateActive
                            ? _c(
                                "div",
                                { staticClass: "col-12" },
                                [
                                  _c("IdentifyCoordinates", {
                                    attrs: {
                                      coordinate:
                                        _vm.coordinatesInfo.coordinate,
                                      projection:
                                        _vm.coordinatesInfo.projection,
                                      resolution:
                                        _vm.coordinatesInfo.resolution,
                                      disabled:
                                        _vm.readonlyFormItem || _vm.loading,
                                      eventIdentify: _vm.eventIdentify,
                                      moduleCode: _vm.moduleCode,
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "panel-control d-flex flex-column flex-fill flex-scroll",
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "panel-control-content d-flex flex-column flex-fill",
                        },
                        [
                          _c("div", { staticClass: "row flex-fill" }, [
                            _c(
                              "div",
                              { staticClass: "col" },
                              [
                                _vm.loading
                                  ? [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "identify-results loading",
                                        },
                                        [
                                          _c("div", {}, [
                                            _c("div", {
                                              staticClass: "full-size-loader",
                                            }),
                                          ]),
                                        ]
                                      ),
                                    ]
                                  : [
                                      _vm.loadingError
                                        ? [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "alert alert-danger",
                                                attrs: { role: "alert" },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                    " +
                                                    _vm._s(_vm.errorMsg) +
                                                    "\n                                "
                                                ),
                                              ]
                                            ),
                                          ]
                                        : _vm.responses
                                        ? [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "identify-results",
                                              },
                                              [
                                                _c("IdentifyViewer", {
                                                  attrs: {
                                                    index: _vm.index,
                                                    responses: _vm.responses,
                                                    requests: _vm.requests,
                                                    missingResponses:
                                                      _vm.missingResponses,
                                                    format: _vm.format,
                                                    activeItemId:
                                                      _vm.activeItemId,
                                                  },
                                                  on: {
                                                    close: _vm.onCloseViewer,
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ]
                                        : _vm._e(),
                                    ],
                              ],
                              2
                            ),
                          ]),
                        ]
                      ),
                    ]
                  ),
                ]
              },
              proxy: true,
            },
          ],
          null,
          false,
          830464851
        ),
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }